import { Div } from "@tblabs/truffle";
import { Basket } from "../../Services/Basket/Basket";
import { BasketItem } from "../../Services/Basket/BasketItem";
import { BasketNotification } from "./Notifications/BasketNotification";


export class ActionBox extends Div
{
    constructor(private _basket: Basket)
    {
        super();
    }
      protected TryAddToBasket(item: BasketItem): void
    {
        if (this._basket.IsAlreadyIn(item))
        {
            this._basket.UpdateItem(item);
            new BasketNotification(item, "Zaktualizowano koszyk");
        }
        else
        {
            this._basket.Add(item);
            new BasketNotification(item, "Dodano do koszyka");
        }
    }
}
